import React from "react";
import { Row } from "react-bootstrap";
import styled from "styled-components";
import {
  DARK_KUBBE,
  PRIMARY_KUBBE,
  SECONDARY_KUBE,
} from "../../../constants/Colors";

const WhoWrapper = styled.div`
  position: relative;
  max-width: 1200px;
  width: 100%;
  margin: auto;
`;

const BorderBox = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 5px solid ${PRIMARY_KUBBE};
  border-radius: 20px;
  pointer-events: none;
  z-index: 0;
`;

const Content = styled.div`
  position: relative;
  padding: 4rem 2rem;
`;

const WhoBadgeContent = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  color: ${DARK_KUBBE};
  padding: 10px 20px;
  border-radius: 20px;
  font-weight: bold;
  font-size: clamp(1.5rem, 2.5vw, 2.5rem);
  white-space: nowrap;
`;

const WhoText = styled.p`
  font-size: clamp(1.2rem, 2.5vw, 1.8rem);
  font-weight: 800;
  text-align: center;
  margin-bottom: 2rem;
`;

const CardContainer = styled.div`
  margin-top: -3rem;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  gap: 1.5rem;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    margin-top: -2.5rem;
  }
`;

const MissionCard = styled.div`
  background-color: ${PRIMARY_KUBBE};
  color: white;
  padding: 1rem;
  border-radius: 10px;
  max-width: 300px;
  width: 100%;
  font-size: 0.95rem;
  text-align: center;
  font-weight: 500;
  z-index: 4;

  h5 {
    font-weight: bold;
    font-size: clamp(1.2rem, 1.5vw, 1.8rem);

    background-color: ${SECONDARY_KUBE};
    border-radius: 10px;
    padding: 0.6rem 0px;
    margin-bottom: 1rem;
  }
`;

function WhoSection() {
  return (
    <Row className="justify-content-center mx-0 py-4">
      <WhoWrapper className="py-4">
        <Content>
          <BorderBox />
          <WhoBadgeContent>QUIÉNES SOMOS</WhoBadgeContent>
          <WhoText>
            En Buena Ruta trabajamos para transformar la logística de cargas en
            Argentina.
          </WhoText>
          <WhoText>
            Nuestra plataforma digital permite gestionar cargas, viajes y
            contactos de manera ágil, con trazabilidad y sin intermediarios.
          </WhoText>
        </Content>

        <CardContainer>
          <MissionCard>
            <h5>NUESTRA MISIÓN</h5>
            Facilitar la conexión entre transportistas y dadores de carga de
            manera eficiente y sostenible.
          </MissionCard>
          <MissionCard>
            <h5>NUESTRA VISIÓN</h5>
            Ser la plataforma líder en logística de cargas en el NOA y
            expandirnos a nivel nacional como referente en soluciones
            tecnológicas para el transporte.
          </MissionCard>
        </CardContainer>
      </WhoWrapper>
    </Row>
  );
}

export default WhoSection;
